/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';
import ReactPlayer from 'react-player';

/* Internal Imports */
/* Components */
// import WistiaEmbed from '@components/Widgets/Wistia/Wistia';
import MidContainer from '@Layout/MidContainer';

/* Services */

/**
 * Renders the Wistia VideoEmbed Component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data from api
 * @param {string} region - Region of the page
 * @param {string} lang - Language of the page
 * @param sectionContent.region
 * @param sectionContent.lang
 * @returns {ReactElement} Wistia VideoEmbed component
 */
const WistiaVideoEmbed = ({ sectionContent, region, lang }) => {
  return (
    <MidContainer w={'100%'}>
      <Box display="flex" w="full" justifyContent="center" id="WistiaEmbed">
        {/* <WistiaEmbed
          width="100%"
          id={sectionContent.videoId}
          // options={sectionContent.videoContainerAttributes}
        /> */}
        {/* <WistiaClass hashedId={sectionContent?.videoId} /> */}
        {/* <WistiaFunctional
          id={sectionContent?.videoId}
          attributes={sectionContent?.videoContainerAttributes}
        /> */}
        {/* <WistiaEmbed
          hashedId={sectionContent?.videoId}
          embedOptions={options}
          isResponsive
        /> */}
        <ReactPlayer
          width="100%"
          height="550px"
          style={{ marginBottom: '60px' }}
          url={`https://home.wistia.com/medias/${sectionContent?.videoId}`}
        />
      </Box>
    </MidContainer>
  );
};

const WistiaFunctional = ({ id, attributes }) => {
  const [video, setVideo] = useState();

  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'wistia_script';
    script.src = '//fast.wistia.com/assets/external/E-v1.js';
    script.charset = 'ISO-8859-1';
    // script.async = true;

    document.body.appendChild(script);
    console.log(document.body.appendChild(script));

    // const scriptParent = document.createElement('script');
    // // scriptParent.id = 'wistia_script';
    // scriptParent.src = `//fast.wistia.com/embed/medias/${id}.jsonp`;
    // scriptParent.charset = 'ISO-8859-1';
    // scriptParent.async = true;

    // document.body.appendChild(scriptParent);
    console.log(document.body.appendChild(script));
    // consoleLog(document.body.appendChild(scriptParent));
    window._wq = window._wq || [];
    _wq.push({
      id: 'wistia_script',
      options: {
        // PLAYBACK
        preload: true,
        muted: true,
        playsinline: true,
        autoPlay: true,
        silentAutoPlay: true,
        endVideoBehavior: 'loop',

        // LAYOUT
        fitStrategy: 'cover',
        videoFoam: true,

        // TRACKING
        copyLinkAndThumbnailEnabled: false,
        doNotTrack: true,
        googleAnalytics: false,
        seo: false,

        // DEFAULT QUALITY
        // qualityMax,
        // qualityMin,

        // UI CONTROLS
        controlsVisibleOnLoad: false,
        fullscreenOnRotateToLandscape: false,
        fullscreenButton: false,
        settingsControl: false,
        qualityControl: false,
        playButton: false,
        playbar: false,
        playbackRateControl: false,
        smallPlayButton: false,
      },
      onReady: async v => {
        const value = await v;

        setVideo(value);
      },
      onHasData: () => {
        console.log('onHasData yes');
      },
    });

    return () => {
      document.body.removeChild(script);
      // document.body.removeChild(scriptParent);
    };
  }, [id]);

  useEffect(() => {
    // if (window !== undefined) {
    //   const vid = window?.Wistia?.api(id);

    //  consoleLog('vid', vid);
    // }
    if (!video) return;
    console.log('first', video);
    video.look();
    video.bind('play', onPlayEvent);
    console.log('first', video);
    // video.bind('beforeremove', function () {
    //   return video.unbind;
    // });
    // return () => {
    //   video.unbind('play', onPlayEvent);
    //   video.remove(); // clean up
    // };
  }, [video]);

  // const myOnReady = video => {
  //  consoleLog('myOnReady', video);
  //   setVideo(video);
  // };

  // const onReady = () => {
  //   console.log('ready', id);
  // };

  const onPlayEvent = () => {
    console.log('The video was just played!', id);
  };

  return (
    <div>
      {/* <Script
        src="//fast.wistia.com/assets/external/E-v1.js"
        strategy="beforeInteractive"
        charSet="ISO-8859-1"
      />
      <Script
        src={`//fast.wistia.com/embed/medias/${id}.jsonp`}
        strategy="beforeInteractive"
        charSet="ISO-8859-1"
      /> */}
      <div
        className={`wistia_embed wistia_async_${id} embedHost=fast.wistia.com`}
        style={{
          width: '100%',
          height: '100%',
        }}
        // videoFoam={true}
        key={id}
        id={id}
      ></div>
    </div>
  );
};

export default WistiaVideoEmbed;
